import {
  debugEnabled,
  lastCheckedAt,
  refreshShellFlags,
  startShellFlagsPolling,
  stopShellFlagsPolling,
} from './shellFlags'

// Per-property debug flag. Reads from property_settings:
//   key='debug', value matching /^(true|1|yes)$/i  →  console.log/info/debug pass through.
// Default state suppresses chatty console output to keep prod clean.
// `console.warn` and `console.error` are NEVER muted — diagnostic signals
// must remain visible even with debug off.
//
// Fail-safe: only an explicit successful response with a truthy value flips
// the flag on. Any error / missing row / falsy value keeps console muted.
//
// The fetch + poller are shared with useMaintenance (see ./shellFlags).

export { debugEnabled }

function check() {
  return refreshShellFlags()
}

function start(intervalMs?: number) {
  startShellFlagsPolling(intervalMs)
}

function stop() {
  stopShellFlagsPolling()
}

// Install console wrappers exactly once. Each wrapper checks the live ref;
// flipping the flag at runtime takes effect immediately on the next call.
let installed = false
export function installConsoleGate() {
  if (installed) return
  installed = true
  const origLog = console.log.bind(console)
  const origInfo = console.info.bind(console)
  const origDebug = console.debug.bind(console)
  console.log = (...args: unknown[]) => { if (debugEnabled.value) origLog(...args) }
  console.info = (...args: unknown[]) => { if (debugEnabled.value) origInfo(...args) }
  console.debug = (...args: unknown[]) => { if (debugEnabled.value) origDebug(...args) }
  // console.warn and console.error stay as-is.
}

export function useDebugMode() {
  return { debugEnabled, lastCheckedAt, check, start, stop }
}
